import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const LoginWrapper = styled.div`
  background-color: white;
  @media(min-width: ${TABLET_WIDTH}px) {
    background-color: #2680EB;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${props => props.app.color1} inset;
    -webkit-text-fill-color: white;
  }
`;

export const InitialWrapper = styled.div`
  background-color: #2680EB;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  button {
    width: 30rem;
    height: 5rem;
    border-radius: 3rem;
    font-size: 1.4rem;
    background: white;
    color: #2680EB;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    margin: 1rem;
  }

  p {
    font-size: 3rem;
    color: white;
    margin-bottom: 4rem;
    width: 25rem;
    font-weight: bold;
  }

  img {
    margin-bottom: 3rem;
  }
`;

export const ButtonLogin = styled.button`
  color: white;
  margin-top: 2rem;
  text-align: center;
  font-size: 1.3rem;
  width: 15rem;
  padding: 1.2rem;
  cursor: pointer;
  border-radius: 2rem;
  box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
  font-weight: bold;
  background: #2680EB;
  margin-bottom: 2rem;
`;



// WEBPACK FOOTER //
// ./src/routes/Login/components/styles.js